import moment from "moment/moment";

export class ReportStatModel {
    constructor(record) {
        this.id = record.id;
        this.className = record.name;
        this.teacherId = record.teacher_id
        this.teacherName = record.teacher_name
        this.startDate = this.formatDate(record.start_date)
        this.endDate = this.formatDate(record.end_date)
        this.percentHomework = this.getValuePercent(record.homework_completion_rate)
        this.percentAttendance = this.getValuePercent(record.attendance_rate)
        this.percentGood = this.getValuePercent(record.satisfaction_rate)
        this.percentPass = this.getValuePercent(record.pass_rate)
    }
    formatDate(date) {
        if (!date) return ''
        return moment(date).format('DD-MM-YYYY')
    }
    getValuePercent(percent) {
        if (!percent) return ''
        return `${percent}%`
    }
}